import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useAttentionChartsDataContext } from './hooks/useAttentionChartsDataContext';

export const PreNatalConsultations = () => {
    const { chartData } = useAttentionChartsDataContext();


    return (
        <SimpleBars
            title={'Total de consultas pré-natal'}
            horizontal={false}
            subtitles={chartData?.preNatalConsultations?.map((item) => item.description)}
            values={chartData?.preNatalConsultations?.map((item) => item.total  ||  0)}
        />
    );
};
